export default __webpack_public_path__ + "static/media/enslavingfire.1972ccf3.png";